import {
    AuthenticationCredentialJSON,
    combineEpics,
    ofType,
    OTPDialogActions,
    PledgerEpic,
    WebAuthnService
} from "@pledger/frontend-commons";
import {map} from "rxjs/operators";
import {ShowPageActions} from "../app/Pages/ShowPageActions";
import {loginWServiceActions} from "../../services/ws/login/loginWServiceActions";
import {AppActions} from "../app/AppActions";
import {webAuthnWServiceActions} from "../../services/ws/webAuthn/webAuthnWServiceActions";
import {mergeMap} from "rxjs";
import {
    PublicKeyCredentialRequestOptionsJSON
} from "@pledger/frontend-commons/dist/services/utils/WebAuthn/PublicKeyCredentialRequestOptionsJSON";
import {LoginActions} from "./LoginActions";

/*const emptyEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) => of(AppActions.EMPTY_ACTION.build());*/



const startWebAuthnAuthenticationSucceededEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(webAuthnWServiceActions.START_AUTHENTICATION_SUCCEEDED_ACTION.type),
        mergeMap(async (action,index) => {
            let jsonOptions : PublicKeyCredentialRequestOptionsJSON = action.payload.data;
            let options : PublicKeyCredentialRequestOptions = WebAuthnService.buildPublicKeyCredentialRequestOptions(jsonOptions);
            try {
                let publicKeyCredential = await WebAuthnService.getCredential(options);
                if (publicKeyCredential!==undefined) {
                    let authenticationCredentialJSON : AuthenticationCredentialJSON = WebAuthnService.buildAuthenticationCredentialJSON(publicKeyCredential);
                    return webAuthnWServiceActions.FINISH_AUTHENTICATION_ACTION.build(jsonOptions.challenge, authenticationCredentialJSON);
                }
            }
            catch(error) {
                console.log(error);
            }
            return LoginActions.WEBAUTHN_AUTHENTICATION_FAILED_ACTION.build();
        })
    );

const finishWebAuthnAuthenticationSucceededEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(webAuthnWServiceActions.FINISH_AUTHENTICATION_SUCCEEDED_ACTION.type),
        mergeMap(async (action,index) => {
            let success = true;
            if (success) {
                return ShowPageActions.SHOW_HOME_ACTION.build(false);
            }
            else {
                return LoginActions.WEBAUTHN_AUTHENTICATION_FAILED_ACTION.build();
            }
        })
    );

const loginSucceededEpic : PledgerEpic<any> = (actions$, state$ ) =>
    actions$.pipe(
        ofType(loginWServiceActions.LOGIN_SUCCEEDED_ACTION.type),
        map((action) => {
            if (action.payload.data.OTPPending) {
                const appContext = state$.value.appContext;
                const customColors = appContext.customColors;
                return OTPDialogActions.SHOW_OTP_DIALOG_ACTION.build(action.payload.data.phoneNumber ?? '',
                    action.payload.data.partialPhoneNumber,
                    'Identification en deux étapes',
                    (tel: string, validationCode: string) => loginWServiceActions.LOGIN_POST_OTP_ACTION.build(action.payload.data.otpTransactionData, validationCode),
                    (tel: string) => loginWServiceActions.LOGIN_ACTION.build(action.payload.initialAction.payload.identifier, action.payload.initialAction.payload.password),
                    customColors.PLEDGER_GREEN_COLOR,
                    customColors.PLEDGER_ORANGE_COLOR,
                    customColors.PLEDGER_START_GRADIENT_COLOR,
                    customColors.PLEDGER_END_GRADIENT_COLOR,
                    customColors.PLEDGER_GREEN_SHADOW_COLOR
                );
            }
            else {
                return ShowPageActions.SHOW_HOME_ACTION.build(false);
              //  return NavigationMenuActions.NAVIGATION_MENU_SELECT_MENU_ITEM_ACTION.build(NavigationMenuItemId.TABLEAU_BORD, ShowPageActions.SHOW_DASHBOARD_ACTION.build(false));
            }
        })
    );

const otpValidationFailedEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(loginWServiceActions.LOGIN_POST_OTP_FAILED_ACTION.type),
        map((action) => {
            return OTPDialogActions.OTP_PHONE_NUMBER_INVALID_ACTION.build();
        })
    );

const otpValidationSucceededEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(loginWServiceActions.LOGIN_POST_OTP_SUCCEEDED_ACTION.type),
        map((action) => {
            const postAction =  ShowPageActions.SHOW_HOME_ACTION.build(false);
           // const postAction = NavigationMenuActions.NAVIGATION_MENU_SELECT_MENU_ITEM_ACTION.build(NavigationMenuItemId.TABLEAU_BORD, ShowPageActions.SHOW_DASHBOARD_ACTION.build(false));
            return OTPDialogActions.CLOSE_OTP_DIALOG_ACTION.build(postAction);
        })
    );

const closeOTPDialogEpic : PledgerEpic<any> = (actions$ ) =>
    actions$.pipe(
        ofType(OTPDialogActions.CLOSE_OTP_DIALOG_ACTION.type),
        map((action) => {
            return action.payload.postAction ?? AppActions.EMPTY_ACTION.build;
        })
    );

export const loginEpics = combineEpics(
    loginSucceededEpic,
    otpValidationFailedEpic,
    otpValidationSucceededEpic,
    closeOTPDialogEpic,
    startWebAuthnAuthenticationSucceededEpic,
    finishWebAuthnAuthenticationSucceededEpic
);
